"use strict";

(
    function($)
    {
        $.fn.video = function()
        {
            $(this).each
            (
                function()
                {
                    $(this).each
                    (
                        function()
                        {
                            $(this).hover
                            (
                                function()
                                {
                                    $(this).get(0).play();
                                },
                                function()
                                {
                                    $(this).get(0).pause();
                                }
                            );

                            $(this).each
                            (
                                function()
                                {
                                    $(this).attr("controls", false).attr("autoplay", false);
                                    $(this).get(0).pause();
                                }
                            );
                        }
                    );
                }
            );
        }
    }
)(jQuery);
